import { render, staticRenderFns } from "./MethodPaypal.vue?vue&type=template&id=1534cf98&scoped=true&"
import script from "./MethodPaypal.vue?vue&type=script&lang=js&"
export * from "./MethodPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534cf98",
  null
  
)

export default component.exports